// extracted by mini-css-extract-plugin
module.exports = {"UniversalNotifications":"UniversalNotifications_UniversalNotifications__1DZVp"};